import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Box,
	Button,
	HStack,
	List,
	ListItem,
	useDisclosure,
} from "@chakra-ui/react";
import { Panel, PanelBody } from "@wordpress/components";
import { sprintf, __ } from "@wordpress/i18n";
import React from "react";
import { ColorPicker, PopoverDrawer } from "../../controls";
import Input from "../../controls/input/Input";
import { RawTypography } from "../../controls/typography/Typography";
import useGlobalStyles from "../../hooks/useGlobalStyles";
import { DEFAULT_IDS } from "./constants";
import ZStack from "../common/ZStack";
import { useSelect } from "@wordpress/data";
import { store as coreStore } from "@wordpress/core-data";
import { GlobalCategoriesStyle } from "../../types";

export const Categories = () => {
	const categories = useSelect(
		(select) =>
			select(coreStore).getEntityRecords("taxonomy", "category", {
				per_page: -1,
			}) as Array<{
				id: number;
				name: string;
			}>,
		[]
	);

	const { styles, updateStyleByKey } = useGlobalStyles();

	const getCategoryColor = (id: number) => {
		const found = (
			styles?.categories_color as GlobalCategoriesStyle[]
		)?.find((cat) => cat.id === id.toString());
		return found?.value || "";
	};

	return (
		<Panel>
			<Box
				as={PanelBody}
				initialOpen={false}
				title={__("Categories")}
				mb="1px"
			>
				<List>
					{categories &&
						categories.map((cat) => (
							<ListItem
								key={cat.id}
								display="flex"
								alignItems="center"
								justifyContent="space-between"
								py="12px"
								mb="0"
							>
								<PopoverDrawer
									label={cat.name}
									trigger={(triggerProps) => (
										<PopoverDrawer.Trigger
											{...triggerProps}
										>
											<ZStack
												items={[
													{
														color: getCategoryColor(
															cat.id
														),
														id: cat.id.toString(),
													},
												]}
											/>
										</PopoverDrawer.Trigger>
									)}
									closeOnFocusOutside
									popoverDivProps={{
										sx: {
											".components-popover__content": {
												p: 4,
											},
										},
									}}
									popoverProps={{
										offset: 16,
									}}
								>
									<ColorPicker
										value={getCategoryColor(cat.id)}
										onChange={(v) => {
											updateStyleByKey(
												"categories_color",
												{
													id: cat.id.toString(),
													name: cat.name,
													value: v,
												}
											);
										}}
										showGlobalPalette={false}
									/>
								</PopoverDrawer>
							</ListItem>
						))}
				</List>
			</Box>
		</Panel>
	);
};
export default Categories;
